import { ShoppingCart } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { ProcurementPage } from './pages/ProcurementPage'

/**
 * Procurement — M9 DataView. Open vendor PO lines across all vendors.
 *
 * Replaces reports.siliconesplus.com/procurement (Open POs tab). Data
 * via `GET /api/reports/vendor-pos`; sidebar badge derives the overdue
 * count from the same payload — no dedicated /count endpoint yet.
 */
export default defineModule({
  id: 'procurement',
  name: 'Procurement',
  shortName: 'POs',
  icon: ShoppingCart,
  navSection: 'purchasing',
  navOrder: 10,
  urlNamespace: '/procurement',
  routes: [{ path: '/', element: ProcurementPage, label: 'Open Vendor POs' }],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing', 'finance'],
  densityDefault: 'comfortable',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g p',

  commandPaletteEntries: [
    {
      label: 'Go to Procurement',
      keywords: ['po', 'procurement', 'vendor', 'purchase'],
      path: '/',
      group: 'modules',
      shortcut: 'g p',
    },
  ],

  deepLinkHandlers: [
    {
      entity: 'vendor',
      label: 'View open POs for this vendor',
      buildPath: (vendorId) => `/?vendor=${vendorId}`,
    },
    {
      entity: 'product',
      label: 'View open POs for this product',
      buildPath: (productId) => `/?product=${productId}`,
    },
  ],
})
